import { CARD_BRANDS } from "@Light/components/account/PaymentMethod/PaymentMethodCard/PaymentMethodCard";
import type { InvoiceResponse } from "@Light/services/lightTypes";
import { useLight } from "@Light/services/light";

export function createInvoiceLink(invoiceNumber: string): string {
  return `/dash/billing/invoice/${encodeURIComponent(invoiceNumber)}/`;
}

export function useInvoiceLink(invoice: InvoiceResponse): string {
  return createInvoiceLink(invoice.number);
}

export type CardDescriptionProps = {};

export const CardDescription: React.FC<CardDescriptionProps> = ({}) => {
  const { useGetPaymentMethodQuery } = useLight();
  const paymentMethod = useGetPaymentMethodQuery();
  if (!paymentMethod.isSuccess) {
    return null;
  }
  return (
    <span>
      {CARD_BRANDS[paymentMethod.data.card_brand ?? ""] ?? "card"} ending in{" "}
      {paymentMethod.data.card_last4}
    </span>
  );
};
